import JSEncrypt from 'jsencrypt/bin/jsencrypt'
import SecureLS from 'secure-ls'

export var ls = new SecureLS({ encodingType: 'AES' })

export var encryptor = new JSEncrypt()
